<!-- 表1填写 -->

<template>
  <div class="tabCage ssTab1E">
    <div class="tabTtl">
      <span>出版物基本信息</span>
      <div class="tabBtns" style="float: right">
        <el-button type="primary" size="small" v-if="modifyFlag" class="importBtn" @click="getCode401HistoryData"
          >导入历史数据</el-button
        >
      </div>
    </div>
    <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div>

    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">出版物中文名称：</td>
            <td class="edInp">
              <el-form-item prop="publication" :inline-message="true">
                <el-input v-model="params.publication" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">出版物外文名称：</td>
            <td class="edInp">
              <el-form-item prop="publicationEnglish" :inline-message="true">
                <el-input
                  v-model="params.publicationEnglish"
                  size="small"
                  placeholder="请输入出版物外文名称"></el-input>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td class="edName">类别：</td>
            <td class="edInp">
              <el-form-item prop="category" :inline-message="true">
                <el-select v-model="params.category" size="small" placeholder="请选择类别">
                  <el-option v-for="item in dicDats['C026']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">文种：</td>
            <td class="edInp">
              <el-form-item prop="recordType" :inline-message="true">
                <el-input v-model="params.recordType" size="small" placeholder="请输入文种"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">刊期：</td>
            <td class="edInp">
              <el-form-item prop="periodicals" :inline-message="true">
                <el-select v-model="params.periodicals" size="small" placeholder="请选择刊期">
                  <el-option v-for="item in dicDats['C014']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">刊号（CN）：</td>
            <td class="edInp">
              <el-form-item prop="cn" :inline-message="true">
                <el-input v-model="params.cn" size="small" placeholder="请输入刊号"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">国际刊号（ISSN）：</td>
            <td class="edInp">
              <el-form-item prop="issn" :inline-message="true">
                <el-input v-model="params.issn" size="small" placeholder="请输入国际刊号"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">批准时间：</td>
            <td class="edInp">
              <el-form-item prop="approvalTime" :inline-message="true">
                <el-date-picker
                  v-model="params.approvalTime"
                  value-format="yyyy-MM-dd"
                  size="small"
                  placeholder="请选择获批时间">
                </el-date-picker>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">上传批复文件：</td>
            <td class="edInp">
              <UpbtnPdf class="upBtn" :fileID="applyFileId" @upFileId="fileTdSetApplyFileId" />
              <div class="tips" style="margin-top: 5px; line-height: 20px">
                <span style="color: red">注：</span>请上传国家出版行政管理部门同意创办的批复文件，如有特殊情况无法上传，
                <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 请对无法上传情况进行说明，上传加盖社章的说明文件。
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上传文件格式为PDF，文件大小不超过10M
              </div>
              <!-- <div class="tips" style="margin-top:-24px;"></div> -->
            </td>
          </tr>

          <tr>
            <td class="edName">媒体形态：</td>
            <td class="edInp areaTime">
              <el-form-item prop="mediaForm" :inline-message="true">
                <el-select v-model="params.mediaForm" size="small" placeholder="请选择" @change="mediaHandle">
                  <el-option
                    v-for="item in dicDats['C025']"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                    placeholder="请选择媒体形态">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="mediaFormQT" :inline-message="true" v-if="mediaType[params.mediaForm] == '其他'">
                <el-input v-model="params.mediaFormQT" size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <!-- <tr v-if="numShow">
            <td class="edName">发行数量(套)：</td>
            <td class="edInp">
              <el-form-item prop="issueQuantity" :inline-message="true">
                <el-input-number controls-position="right" :min="0" :precision="0" v-model="params.issueQuantity"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr v-if="numShow">
            <td class="edName">发行单价(元)：</td>
            <td class="edInp">
              <el-form-item prop="unitPrice" :inline-message="true">
                <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.unitPrice"
                  size="small"></el-input-number>
              </el-form-item>

                    </td>
                  </tr> -->
          <tr>
            <td class="edName">是否缴送样本：</td>
            <td class="edInp areaTime">
              <el-form-item prop="isSampleDelivery" :inline-message="true">
                <el-select v-model="params.isSampleDelivery" size="small" placeholder="请选择">
                  <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <span class="tips">按规定向国家版本馆、国家图书馆缴送样本</span>
            </td>
          </tr>
          <tr>
            <td class="edName">出版范围：</td>
            <td class="edInp">
              <el-form-item prop="publicationScope" :inline-message="true">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="params.publicationScope"
                  size="small"
                  placeholder="请输入出版范围"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">发行范围：</td>
            <td class="edInp">
              <el-form-item prop="issueScope" :inline-message="true">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="params.issueScope"
                  size="small"
                  placeholder="请输入发行范围">
                </el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">读者对象：</td>
            <td class="edInp">
              <el-form-item prop="readers" :inline-message="true">
                <el-input type="textarea" :rows="3" v-model="params.readers" size="small" placeholder="请输入读者对象">
                </el-input>
              </el-form-item>
            </td>
          </tr>
        </table>
        <div class="headBar">
          <span>申报人信息</span>
        </div>
        <div class="editArea">
          <table>
            <tr>
              <td class="edName">申报人：</td>
              <td class="edInp">
                <el-input v-model="declare.personnel" size="small" placeholder="请输入申报人"></el-input>
              </td>
            </tr>
            <tr>
              <td class="edName">联系方式：</td>
              <td class="edInp">
                <el-input v-model="declare.contact" size="small" placeholder="请输入申报人联系方式"></el-input>
              </td>
            </tr>
            <tr>
              <td class="edName">申报时间：</td>
              <td class="edInp">
                <el-input v-model="params.updatedAt" size="small" :disabled="true"></el-input>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="modifyFlag" type="primary" @click="editSave('paramCk')" size="small" :disabled="submiting">
        <span v-if="submiting">提交中</span>
        <span v-else>保存</span>
        <i v-if="submiting" class="el-icon-loading"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsSEt1";
import {
  ssSave1,
  ssRead1,
  code401HistoryData,
  getLxdzModifyFlagByPublication, // zym.判断数据是否可以修改
} from "@/api/pressRole/pressSuccessive";
import UpbtnPdf from "@/views/components/uploadPdf";
export default {
  components: {
    UpbtnPdf,
  },
  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      numShow: true,
      dicDats: {},
      isNot: {},
      isSub: {},
      mediaType: {},
      submiting: false,
      layDasion: 1,
      declare: {
        personnel: "",
        contact: "",
      },

      applyFileId: "",

      modifyFlag: false,
    };
  },

  methods: {
    // zym.批复文件
    fileTdSetApplyFileId: function (id) {
      this.params.applyFileId = id;
      this.applyFileId = id;
    },
    fileTdSet1: function (dat) {
      // this.params.professionalCertificateId = dat;
    },
    editSave: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId; // *publicationOrganizationMaterial的主键
          this.params.materialCode = this.$route.query.mtcode;
          if (!this.declare.personnel) {
            this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error('请填写正确的手机号');
          //   return
          // }
          if (!this.declare.contact) {
            this.$message.error("申报人联系方式必填");
            return;
          }

          // !出版物基本信息保存
          ssSave1({
            data: this.params,
            organizationPersonnel: this.declare,
            // plxdzPublication: this.params,
            // organizationPersonnel: this.declare,
          })
            .then((response) => {
              // console.log('response=', JSON.stringify(response));
              let tipCode = response.payload.tipCode;
              let tipMessage = response.payload.tipMessage;
              if (tipCode == "fail") {
                this.$message({
                  message: tipMessage,
                  type: "error",
                });
              } else {
                this.submiting = false;
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });

                this.goBack();
              }
            })
            .catch((error) => {
              this.submiting = false;
            });
        } else {
          return false;
        }
      });
    },
    //获取历史导入数据
    getCode401HistoryData: function () {
      let that = this;
      this.imgId = "";
      const loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      code401HistoryData({
        publishMaterialId: this.$route.query.mtId,
      })
        .then((response) => {
          loading.close();
          // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
          that.params = { ...that.params, ...response.plxdzPublication, publishMaterialId: that.$route.query.mtId };
          // that.imgId = response.plxdzPublication.yyzzId;
          if (response.pOrganizationPersonnel !== null) {
            that.declare.contact = response.pOrganizationPersonnel.contact;
            that.declare.personnel = response.pOrganizationPersonnel.personnel;
            that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
          }
          that.layChange();
        })
        .catch((error) => {
          that.submiting = false;
        });
    },
    dictInit: function () {
      let nameArr = ["C026", "C014", "C012", "C025", "C018"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr",
      });
      newPromise.then((result) => {
        this.dicDats = result;
        this.isNot = this.$store.getters.dictionary["C018"];
        this.isSub = this.$store.getters.dictionary["C012"];
        this.mediaType = this.$store.getters.dictionary["C025"];
        for (let key in this.isNot) {
          if (this.isNot[key] == "是") {
            // this.params.isIndependentLP = key;// !是否独立法人，这个页面应该不需要
          } else if (this.isNot[key] == "否") {
            this.params.isSampleDelivery = key;
          }
        }

        if (this.$route.query.pgress == 2) {
          this.tabReEdit();
        } else {
          this.modifyFlag = true;
        }
      });
    },

    // !读取信息
    tabReEdit: function () {
      console.log("tabReEdit...");
      let vm = this;
      ssRead1({
        publishMaterialId: this.$route.query.mtId, // *publicationOrganizationMaterial的主键
        judgeModify: true,
      }).then((response) => {
        vm.params = response.plxdzPublication;

        vm.applyFileId = response.plxdzPublication.applyFileId;

        this.declare.contact = response.pOrganizationPersonnel.contact;
        this.declare.personnel = response.pOrganizationPersonnel.personnel;
        this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

        this.modifyFlag = response.modifyFlag;
        console.log("modifyFlag=", this.modifyFlag);

        if (vm.mediaType[vm.params.mediaForm] == "电子-信息网络出版") {
          vm.numShow = false;
          vm.params.issueQuantity = 0;
          vm.params.unitPrice = 0;
        } else {
          vm.numShow = true;
        }
      });
    },

    fileTdSet: function (id) {
      this.params.yyzzId = id;
    },

    layChange: function () {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },

    mediaHandle: function () {
      if (this.mediaType[this.params.mediaForm] == "电子-信息网络出版") {
        this.numShow = false;
        this.params.issueQuantity = 0;
        this.params.unitPrice = 0;
      } else {
        this.numShow = true;
      }
    },

    goBack: function () {
      this.$router.go(-1);
    },
    // zym.判断是否可以修改
    getLxdzModifyFlagByPublication: function () {
      console.log("getLxdzModifyFlagByPublication...");
      let vm = this;
      getLxdzModifyFlagByPublication({
        publishMaterialId: this.$route.query.mtId, // *publicationOrganizationMaterial的主键
      }).then((response) => {
        vm.modifyFlag = response.payload;
      });
    },
  },
  created: function () {
    // zym.判断是否可以修改
    // this.getLxdzModifyFlagByPublication();

    console.log("this.$route.query.mtId=", this.$route.query.mtId);
    console.log("this.$route.query.mtcode=", this.$route.query.mtcode);
    this.dictInit();
    this.params.publication = this.$route.query.bookName;
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.ssTab1E {
  margin-top: 0;

  .edInp .el-input-number {
    width: 300px;
  }

  .el-textarea {
    width: 450px;
  }

  .areaTime .el-form-item {
    display: inline-block;
    vertical-align: middle;
  }

  .tips {
    margin-left: 12px;
  }
}

.el-date-editor {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// ssTab1.vue?ec1f4b28